<template>
    <div class="CommunityFamilyList">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h2><font-awesome-icon :icon="['fa', 'people-group']" /> Community Families <span v-b-tooltip.hover title="Add Family" style="float:right;"><font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="olive-green-text pointer" /></span></h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <GenericDataTable ref="datatable"
                                  @recordclicked="OnRecordClicked"
                                  :table-fields="Fields"
                                  :data-filters="Filters"
                                  :table-slots="Slots"
                                  data-endpoint="StrongFamilies/CommunityFamilies"
                                  data-method="GET"
                                  :load-indicator="true"
                                  :data-commit-name="null" 
                                  :load-data-on-mounted="false"/>
                </div>
            </div>
        </div>
        <NewCommunityFamily ref="component-add-record" @updatetable="OnUpdateTable" />
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
    library.add(faPeopleGroup);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    import GenericDataTable from '../../../Core/UI/GenericDataTable.vue';
    import NewCommunityFamily from './NewCommunityFamily.vue';

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        created() {
            //this.$store.commit("Clients.ClientProfiles.Clear");
            //this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            EventBus.$on('global-update-initiated', this.OnUpdateTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        props: [],
        data: function () {
            return {
                //DATA TABLE CONFIGURATION
                Fields: [
                    {
                        name: '__slot:OpenProfile',
                        title: 'Name',
                        sortField: 'Name',
                    },
                    {
                        name: 'Name',
                        title: 'Name',
                        sortField: 'Name',
                        visible: false
                    },
                    {
                        name: 'SubProgramTerritory.Name',
                        title: 'Territory',
                        sortField: 'SubProgramTerritory.Name'
                    },
                    {
                        name: 'PhysicalAddress.CityState',
                        title: 'Location',
                        sortField: 'PhysicalAddress.CityState'
                    },
                    {
                        name: 'StatusCache',
                        title: "Status",
                        sortField: 'StatusCache'
                    }
                ],
                Filters: [
                    {
                        Name: "Status",
                        Label: "Status",
                        Options: [
                            {
                                text: "All",
                                value: "All"
                            },
                            {
                                text: "Open Inquiry",
                                value: "Open Inquiry"
                            },
                            {
                                text: "Open Engagement",
                                value: "Open Engagement"
                            },
                            {
                                text: "Hosting in Progress",
                                value: "Hosting in Progress"
                            },
                            {
                                text: "Closed Engagement",
                                value: "Engagement Closed"
                            },
                            {
                                text: "Closed Inquiry",
                                value: "Inquiry Closed"
                            },
                            {
                                text: "No History",
                                value: "No History"
                            }
                        ],
                        Value: "Hosting in Progress"
                    },
                    {
                        Name: "SubProgramID",
                        Label: "Program",
                        Options: [

                        ],
                        Value: ""
                    },
                    {
                        Name: "SubProgramTerritoryID",
                        Label: "Territory",
                        Options: [

                        ],
                        Value: null
                    },
                ],
                Slots: [
                    {
                        Name: "OpenProfile",
                        DisplayProperty: "Name",
                        EventName: "recordclicked"
                    }
                ]
            };
        },
        methods: {
            //UI
            ShowAddRecord() {
                this.$refs["component-add-record"].ShowModal();
            },
            OnUpdateTable(loadIndicator = false) {
                this.$refs["datatable"].GetData(loadIndicator);
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnRecordClicked(rowData) {
                this.$store.commit("CommunityFamilies.Profiles.Append", rowData);
                this.$parent.ChangePaneShown(rowData.Id);
            }
        },
        components: {
            GenericDataTable,
            NewCommunityFamily
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            //Seed Sub Program Options
            if (this.SubProgramOptions.length > 0) {
                this.Filters[1].Value = this.SubProgramOptions[0].value;
            }
            this.Filters[1].Options = this.SubProgramOptions;

            //Seed SubProgram Territory Options
            this.Filters[2].Options = this.SubProgramTerritoryOptions;
            this.Filters[2].Options.push({ text: "All", value: null })

            this.OnUpdateTable(false);
        }
    }
</script>

<style scoped>
</style>